enum ApprovalStatusEnum {
    Approved = 'APPROVED',
    NotApproved = 'NOT_APPROVED',
}

export default ApprovalStatusEnum;
